import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // Ana sayfa - Dış panelden gelen URL: /?t={token}&session={session_id}
  {
    path: '/',
    name: 'Entry',
    component: () => import('@/views/EntryView.vue'),
    meta: { title: 'WeAccess.AI Console' }
  },
  // Live Analysis - Session ID ile doğrudan erişim
  {
    path: '/analysis/:sessionId',
    name: 'LiveAnalysis',
    component: () => import('@/views/LiveAnalysisView.vue'),
    meta: { title: 'Live Analysis' }
  },
  // Geçersiz erişim sayfası
  {
    path: '/invalid-access',
    name: 'InvalidAccess',
    component: () => import('@/views/InvalidAccessView.vue'),
    meta: { title: 'Erişim Sağlanamadı' }
  },
  // Oturum sonlandırıldı sayfası
  {
    path: '/session-ended',
    name: 'SessionEnded',
    component: () => import('@/views/SessionEndedView.vue'),
    meta: { title: 'Oturum Sonlandı' }
  },
  
  // Tüm bilinmeyen route'ları yakala
  {
    path: '/:pathMatch(.*)*',
    redirect: '/invalid-access'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Sayfa başlığını ayarla
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | WeAccess.AI` || 'WeAccess.AI'
  next()
})

export default router
